<aside class="side" [class.is-collapsed]="isCollapsed" [class.is-ready]="isReady">
  <!-- Brand row: same height as the top bar, so the two read as one band -->
  <div class="side__brand">
    <a
      routerLink="/organization/dashboard"
      class="side__logo"
      aria-label="Black Konnect dashboard"
    >
      <img src="/images/BlackKonnectLogo_light.png" alt="" class="side__logo-img side__logo-img--on-dark" />
      <img src="/images/BlackKonnectLogo_dark.png" alt="" class="side__logo-img side__logo-img--on-light" />
    </a>
    <button
      type="button"
      class="bk-icon-btn side__collapse"
      (click)="toggleSidebar()"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!isCollapsed"
      [matTooltip]="isCollapsed ? 'Expand' : ''"
      matTooltipPosition="right"
    >
      <span class="bk-sym" aria-hidden="true">{{
        isCollapsed ? "left_panel_open" : "left_panel_close"
      }}</span>
    </button>
  </div>

  <div class="side__body">
    <!-- Organisation -->
    <div
      class="side__org"
      [matTooltip]="isCollapsed ? OrganizationName : ''"
      matTooltipPosition="right"
    >
      <span class="side__mono" aria-hidden="true">
        @if (institutionLogo) {
          <img [src]="institutionLogo" alt="" />
        } @else {
          {{ orgInitials }}
        }
      </span>
      <span class="side__org-name">{{ OrganizationName || "Organization" }}</span>
    </div>

    <!-- Channel tabs -->
    @if (channels.length > 1) {
      <div
        class="side__channels"
        [class.is-stacked]="channels.length > 2"
        role="radiogroup"
        aria-label="Channel"
        [style.--n]="channels.length"
        [style.--i]="channelIndex"
      >
        @for (channel of channels; track channel.title; let i = $index) {
          <button
            type="button"
            role="radio"
            class="side__channel"
            [class.is-on]="i === channelIndex"
            [attr.aria-checked]="i === channelIndex"
            [attr.tabindex]="i === channelIndex ? 0 : -1"
            (click)="selectChannel(channel.title)"
            (keydown.arrowRight)="stepChannel($event, 1)"
            (keydown.arrowDown)="stepChannel($event, 1)"
            (keydown.arrowLeft)="stepChannel($event, -1)"
            (keydown.arrowUp)="stepChannel($event, -1)"
          >
            <span class="bk-sym" aria-hidden="true">{{ channelIcon(channel) }}</span>
            <span class="side__channel-label">{{ channel.title }}</span>
          </button>
        }
        <span class="side__thumb" aria-hidden="true"></span>
      </div>
    }

    <!-- The selected channel's tools; the pill marks the page you're on -->
    <nav
      class="side__nav"
      [class.has-pill]="activeIndex >= 0"
      [style.--a]="activeIndex"
      [attr.aria-label]="(currentChannel?.title ?? 'Main') + ' navigation'"
    >
      <span class="side__pill" aria-hidden="true"></span>
      @for (item of currentChannel?.children ?? []; track item.title; let i = $index) {
        <app-sidebar-link
          class="side__item"
          [style.--k]="i"
          [iconName]="item.iconName"
          [title]="item.title"
          [link]="item.link!"
          [isCollapsed]="isCollapsed"
          [badge]="item.badge || 0"
          [badgeLabel]="item.badgeLabel || ''"
          [onPill]="true"
        />
      }
      @for (item of looseLinks; track item.title) {
        <app-sidebar-link
          [iconName]="item.iconName"
          [title]="item.title"
          [link]="item.link!"
          [isCollapsed]="isCollapsed"
        />
      }
    </nav>
  </div>

  <div class="side__foot">
    <!-- The next scheduled send, counting down on every page but the dashboard -->
    @if (showNextSend) {
      <button
        type="button"
        class="side__next"
        (click)="nextSendOpen.emit()"
        [attr.aria-label]="nextTooltip"
        [matTooltip]="isCollapsed ? nextTooltip : ''"
        matTooltipPosition="right"
      >
        <span class="side__next-icon" aria-hidden="true">
          <span class="bk-sym">schedule_send</span>
        </span>
        <span class="side__next-text" aria-hidden="true">
          <span class="side__next-label">Next send</span>
          <span class="side__next-when">{{ nextCountdown }}</span>
          <span class="side__next-subject">{{ nextSend?.subject }}</span>
        </span>
        <span class="side__next-short" aria-hidden="true">{{ nextCountdownShort }}</span>
      </button>
    }
    <app-sidebar-link
      iconName="settings"
      title="Settings"
      link="/organization/settings"
      [isCollapsed]="isCollapsed"
    />
    <a
      class="side__credit"
      href="https://blacktechnologies.io/"
      target="_blank"
      rel="noopener"
    >
      Powered by Black Technologies<span class="bk-sr-only"> (opens in a new tab)</span>
    </a>
  </div>
</aside>
